// Onboarding links (the path after the domain, e.g. 'pl_value') where the CookieYes tag in GTM must not fire
export const COOKIEYES_DISABLED_LANDINGS: string[] = ['flpm_rt', 'pl_value'];
